module.exports = __webpack_public_path__ + "img/5.f8f25ba8.png";